import moment from "moment";
import { LoadState } from "../../../constants/enums";
import { formatDate } from "../../../helpers";
import { STANDARD_APP_DATE_FORMAT } from "../../../constants/constants";

export interface IHabitationalQuoteState {
  list: IHabitationalQuote[];
  data: IHabitationalQuote;
  loading: LoadState;
  error: string | null;
}

export interface IHabitationalQuote {
  customer_policy_id: number | null;
  incremental_number: number | null;
  customer_id: string | null;
  province: string | null;
  default_vehicle_type: string | null;
  customer_type: string | null;
  customer_details: {
    given_name: string | null;
    middle_name: string | null;
    surname: string | null;
    address: string | null;
    postal_code: string | null;
    city: string | null;
    country: string | null;
    province_or_state: string | null;
    home_phone: string | null;
    date_of_birth: string | null;
  };
  authorization: {
    type_of_consent: string | null;
    consent_statement: string | null;
    quote_type: string | null;
    signed_application_file: string | null;
    apply_customer_distinction: string | null;
  };
  participating_companies: {
    aviva_group_of_insurers: boolean;
    definity_insurance_company: boolean;
    the_definition_of_canada: boolean;
    intact: boolean;
  };

  risk_location_incremental_number: number[];
  interested_party_incremental_number: number[];
  coverage_incremental_number: number[];
  claims_incremental_number: number[];
  schedule_detail_incremental_number: number[];
  effective_date: string | null;
  status: string;
}

export const initialHabitationalQuoteState: IHabitationalQuoteState = {
  list: [],
  loading: LoadState.NotLoaded,
  error: null,
  data: {
    customer_policy_id: 0,
    incremental_number: null,
    customer_id: null,
    province: "ON",
    default_vehicle_type: null,
    customer_type: "Individual",
    customer_details: {
      given_name: null,
      middle_name: null,
      surname: null,
      address: null,
      postal_code: null,
      city: null,
      province_or_state: null,
      home_phone: null,
      date_of_birth: null,
      country: null,
    },
    authorization: {
      type_of_consent: null,
      consent_statement: null,
      quote_type: null,
      signed_application_file: null,
      apply_customer_distinction: null,
    },
    participating_companies: {
      aviva_group_of_insurers: false,
      definity_insurance_company: false,
      the_definition_of_canada: false,
      intact: false,
    },
    effective_date: formatDate(moment().format(STANDARD_APP_DATE_FORMAT)),
    status: "ACTIVE",
    risk_location_incremental_number: [],
    interested_party_incremental_number: [],
    coverage_incremental_number: [],
    claims_incremental_number: [],
    schedule_detail_incremental_number: []
  },
};
